import { useState, useEffect } from "react";
import { Menu, Layout, Button, Drawer } from "antd";
import {
  HomeOutlined,
  FormOutlined,
  FileOutlined,
  FileTextOutlined,
  UserOutlined,
  PictureOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import logo_dark from "../img/logo_white.png";
import AppFooter from "../components/Footer";
import "./MainLayout.css";
import anketaService from "../services/anketa.service";
import clanakService from "../services/clanak.service";

const { Header, Content } = Layout;

function MainLayoutKorisnik() {
  const location = useLocation();
  const navigate = useNavigate();
  const [sectionTitle, setSectionTitle] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const path = location.pathname;

    const anketaMatch = path.match(/\/ankete\/(\d+)/);
    const clanakMatch = path.match(/\/clanci\/(\d+)/);

    if (anketaMatch) {
      const anketaId = anketaMatch[1];
      anketaService
        .getById(anketaId)
        .then((response) => {
          setSectionTitle(response.data.naziv);
        })
        .catch((err) => {
          setSectionTitle("Anketa");
        });
      return;
    }
    if (clanakMatch) {
      const clanakId = clanakMatch[1];
      clanakService
        .getById(clanakId)
        .then((response) => {
          setSectionTitle(response.data.naslov);
        })
        .catch((err) => {
          setSectionTitle("Clanak");
        });
      return;
    }

    const routeTitles = {
      "/home": "Početna stranica",
      "/sviDokumenti/1": "Želimo da podijelimo sa vama",
      "/sviDokumenti/2": "Naši materijali",
      "/sviDokumenti/3": "Izvještaji",
      "/sviClanci/1": "Ko smo mi?",
      "/sviClanci/2": "Kako je sve počelo?",
      "/sviClanci/3": "Šta interesuje naše studente?",
      "/sviClanci/4": "Naša postignuća",
      "/ankete/sve": "Ankete",
      "/galerija": "Galerija",
    };

    setSectionTitle(routeTitles[path] || "");
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuClick = ({ key }) => {
    navigate(key);
    setDrawerVisible(false);
  };

  const selectedKey = location.pathname === "/" ? "/home" : location.pathname;

  const renderMenu = () => (
    <Menu selectedKeys={[selectedKey]} mode="inline" onClick={handleMenuClick}>
      <Menu.Item key="/home" icon={<HomeOutlined />}>
        Početna stranica
      </Menu.Item>

      <Menu.SubMenu key="/dokumenti" icon={<FileOutlined />} title="Dokumenti">
        <Menu.Item key="/sviDokumenti/1">
          Želimo da podijelimo sa vama
        </Menu.Item>
        <Menu.Item key="/sviDokumenti/2">Naši materijali</Menu.Item>
        <Menu.Item key="/sviDokumenti/3">Izvještaji</Menu.Item>
      </Menu.SubMenu>

      <Menu.SubMenu key="/clanci" icon={<FileTextOutlined />} title="Članci">
        <Menu.Item key="/sviClanci/1">Ko smo mi?</Menu.Item>
        <Menu.Item key="/sviClanci/2">Kako je sve počelo?</Menu.Item>
        <Menu.Item key="/sviClanci/3">
          Šta interesuje naše studente?
        </Menu.Item>
        <Menu.Item key="/sviClanci/4">Naša postignuća</Menu.Item>
      </Menu.SubMenu>

      <Menu.Item key="/ankete/sve" icon={<FormOutlined />}>
        Ankete
      </Menu.Item>
      <Menu.Item key="/galerija" icon={<PictureOutlined />}>
        Galerija
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh", backgroundColor: "transparent" }}>
      <Header className="custom-header">
        <div className="header-left">
          <Button
            className="menu-toggle"
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
          />
          <Link to="/home">
            <img
              src={logo_dark}
              alt="Logo"
              className="header-logo clickable-logo"
            />
          </Link>
        </div>

        <div className="header-right">
          <Button
            className="user_button"
            icon={<UserOutlined />}
            onClick={() => navigate("/login")}
          >
            Prijava
          </Button>
        </div>
      </Header>

      <div className="docs-div2">
        <p className="docs-p">{sectionTitle}</p>
      </div>

      <Drawer
        title="Navigacija"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width="20%"
        bodyStyle={{ padding: 0 }}
        style={{ height: "100%", maxHeight: "100%" }}
      >
        {renderMenu()}
      </Drawer>
      <Layout className="site-layout">
        <Content style={{ minHeight: "280px" }}>
          <Outlet />
        </Content>
        <AppFooter />
      </Layout>
    </Layout>
  );
}

export default MainLayoutKorisnik;
